import { useMobileModeStore } from '@/common/store/mobile-mode';
import { computed, ComputedRef } from 'vue';

export function useMobile(): { isMobile: ComputedRef<boolean>; isViewportSmallerOrEqualMd: ComputedRef<boolean> } {
    const mobileModeStore = useMobileModeStore();

    const isMobile = computed(() => mobileModeStore.state.isMobile);

    const isViewportSmallerOrEqualMd = computed(() => mobileModeStore.getters.isViewportSmallerOrEqualMd);

    return { isMobile, isViewportSmallerOrEqualMd };
}

export default useMobile;
